import React from "react";

interface SuggestedTagsSectionProps {
  suggestedTags: string[];
  onAddSuggestedTag: (tag: string) => void;
}

export function SuggestedTagsSection({ suggestedTags, onAddSuggestedTag }: SuggestedTagsSectionProps) {
  if (suggestedTags.length === 0) return null;

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      <span className="text-xs text-gray-500 mr-1">Suggested tags:</span>
      {suggestedTags.map(tag => (
        <button
          key={tag}
          type="button"
          onClick={() => onAddSuggestedTag(tag)}
          className="badge badge-primary gap-2 cursor-pointer hover:badge-primary-focus"
        >
          {tag}
        </button>
      ))}
    </div>
  );
} 